
const siteTitleMain: Array<string> = [
    '¡Iniciemos con la emisión del seguro!',
    '¡Iniciemos con la emisión del seguro!',
    '¡Continua con la emisión de tu seguro!',
    '¡Continua con la emisión de tu seguro!',
    '¡Continua con la emisión de tu seguro!',
    '¡Continua con la emisión de tu seguro!',
    '¡Ya casi emites tu seguro!',
    '',
    '',
    'Iniciemos a cotizar el seguro de tu automóvil',
    '',
    '',
]

const txtBack = 'Regresar';
const txtNext = 'Siguiente';
const txtSave = 'Generar oferta';


const lstPageTitle: Array<IPageInfo> = [
    {
        index: 0,
        indexBar: 1,
        title1: 'Continuación datos personales',
        title2: 'Espacios requeridos',
        title3: '',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 1,
        indexBar: 1,
        title1: 'Sujetos Obligados y PEP',
        title2: 'Espacios requeridos',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 2,
        indexBar: 2,
        title1: 'Continuación datos personales',
        title2: 'Espacios requeridos',
        title3: '',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,

    {
        index: 3,
        indexBar: 3,
        title1: 'Detalles del vehículo',
        title2: 'Espacios requeridos',
        title3: 'Favor completa los datos de tu vehículo para continuar con el proceso de emisión de tu póliza',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 4,
        indexBar: 4,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
    {
        index: 5,
        indexBar: 5,
        title1: 'Pago de la Póliza',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 6,
        indexBar: 5,
        title1: 'Pago de la Póliza',
        title2: 'Espacios requeridos',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 7,
        indexBar: 0,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
    {
        index: 8,
        indexBar: 0,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
    {
        index: 9,
        indexBar: 4,
        title1: 'Detalles del vehículo',
        title2: 'Espacios requeridos',
        title3: 'Favor completa los datos de tu vehículo para continuar con el proceso de emisión de tu póliza',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 10,
        indexBar: 0,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
    {
        index: 11,
        indexBar: 0,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
]

const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '15px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",
            color: state.isSelected ? "white" : "#4D4D4D",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '15px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            // color:'#4D4D4D',
            boxShadow: 0,
            "text-align-last": "left",
            '&:hover': {
                border: '0 !important',
            },
            selectProps: {
                backgroundColor: "#008964",
                color: '#ffffff'
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const catSiNo: Array<ICatalog> = [
    { value: 'S', text: 'Si' } as ICatalog,
    { value: 'N', text: 'No' } as ICatalog
]
const catCardType: Array<ICatalog> = [
    { value: 'TR', text: 'Débito' } as ICatalog,
    { value: 'TZ', text: 'Crédito' } as ICatalog
]

const catCivilStatus: Array<ICatalog> = [
    { value: 'C', text: 'Casado(a)', text2: 'C' } as ICatalog,
    { value: 'S', text: 'Soltero(a)', text2: 'S' } as ICatalog,
    { value: 'D', text: 'Divorciado(a)', text2: 'D' } as ICatalog,
    { value: 'V', text: 'Viudo(a)', text2: 'V' } as ICatalog,
    { value: 'U', text: 'Union Libre', text2: 'U' } as ICatalog,
]


const catGender: Array<ICatalog> = [
    { value: 'F', text: 'Femenino' } as ICatalog,
    { value: 'M', text: 'Masculino' } as ICatalog,
]

const catTypeDocument: Array<ICatalog> = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

const catCICACReasonRejection: Array<ICatalog> = [
    { value: '2', text: 'Cliente que no tiene firma digital y vive en extranjero' },
    { value: '3', text: 'Cliente que no desea que su información esté en otras bases de datos' },
    { value: '4', text: 'Otros' },
];

const catPaymentFrequency = [
    { value: 'A', value2: 1, text: 'Anual' },
    { value: 'M', value2: 12, text: 'Mensual' },
    { value: 'S', value2: 2, text: 'Semestral' },
    { value: 'T', value2: 4, text: 'Trimestral' },
]

const pagesType = {
    personalData: 0,
    CICAC: 1,
    personalDataSpouse: 2,
    VehicleDetails: 3,
    Evicertia: 4,
    PV: 5,
    SaveCard: 6,
    PaymentFinish: 7,
    Finish: 8,
    UsedCarFile: 9,
    UsedCarFileFinish: 10,
    NoAccept: 11
}

const dataDefault = {
    civilStatusSpouse: 'C'
}

const homePageLAFISE = 'https://www.lafise.com/slcr/';

export {
    siteTitleMain,
    lstPageTitle,
    customStyles,
    catSiNo,
    catCivilStatus,
    catGender,
    catCardType,
    pagesType,
    dataDefault,
    catTypeDocument,
    catCICACReasonRejection,
    catPaymentFrequency,
    homePageLAFISE
}